import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { DRSService } from "src/app/services/operations/drs.service";
import { regexPattern } from "src/app/models/validator";
import { AWBDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/awb-delete.component";
import { CheckboxCellComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-cell.component";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, finalize, forkJoin, lastValueFrom, map } from "rxjs";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ChildAWBGridComponent } from "../../manifest/child-awbmodel/child-awb.component";
import { UserManagementService } from "src/app/services/user-management.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { Utilities } from "src/app/models/utilities";
import { Title } from "@angular/platform-browser";
import { CompanyService } from "src/app/services/company.service";

@Component({
  selector: 'app-drs',
  templateUrl: './drs.component.html',
  styleUrls: ['./drs.component.scss']
})
export class DRSComponent implements OnInit {
  @ViewChild('addItemsBtn') addItemsBtn: ElementRef;
  @ViewChild('submitBtn') submitBtn: ElementRef;
  @ViewChild('awbNoRef') awbNoRef: ElementRef;
  drsForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted: boolean;
  serviceCenterList: any[] = [];
  scannedByList = ['AWB number', 'Reference Number'];
  Id: number = null;
  vehicleTypeList = ['Van', 'Bike', 'Train']
  drsFullNo: any = null;
  awbNoList: any[];
  childAWBNoList = [];
  companyList: any[] = [];
  awbNoArray = [];
  awbNumber: any;
  isListEdit = false;
  isActionAllowed = true;
  public isCollapsed = true;
  isDelivered = false;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: ' AWB No.', field: 'awbnumber', filter: true, minWidth: 150, pinned: 'left' },
    {
      headerName: ' Booking Date',
      field: 'bookingdate',
      cellRenderer: (params: { value: any }) => {
        const { dateString } = this.utilities.FormatDateWithTime(0, params.value);
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`
      }
    },
    { headerName: ' Origin', field: 'shippercity', filter: true },
    { headerName: ' Destination', field: 'consigneecity', filter: true },
    { headerName: 'Shipper', field: 'shippername', filter: true },
    { headerName: 'Consignee', field: 'consigneename', filter: true },
    { headerName: 'Customer', field: 'customername', filter: true },
    { headerName: 'Weight', field: 'actualweight', filter: true, cellStyle: { textAlign: 'end' } },
    { headerName: 'Amount', field: 'totalamount', filter: true },
    {
      headerName: 'Status',
      field: 'status',
      pinned: 'right',
      minWidth: 145,
      cellRenderer: (params: { value: string; }) => {
        // console.log('params', params);
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'SHIPMENT_BOOKED') {
          statusHtml = `<span class="badge bg-light">BOOKED</span>`;
        } else if (params.value === 'SHIPMENT_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">RECEIVED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">PARTIALLY RECEIVED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_BAGGED') {
          statusHtml = `<span class="badge bg-info">PARTIALLY BAGGED</span>`;
        } else if (params.value === 'SHIPMENT_BAGGED') {
          statusHtml = `<span class="badge bg-info">BAGGED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_MANIFESTED') {
          statusHtml = `<span class="badge bg-info">PARTIALLY MANIFESTED</span>`;
        } else if (params.value === 'SHIPMENT_MANIFESTED') {
          statusHtml = `<span class="badge bg-info">MANIFESTED</span>`;
        } else if (params.value === 'SHIPMENT_SENT') {
          statusHtml = `<span class="badge bg-info">SENT</span>`;
        } else if (params.value === 'SHIPMENT_MISROUTED') {
          statusHtml = `<span class="badge bg-danger">MISROUTED</span>`;
        } else if (params.value === 'OUT_FOR_DELIVERY') {
          statusHtml = `<span class="badge bg-warning">OUT FOR DELIVERY</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_DELIVERED') {
          statusHtml = `<span class="badge bg-warning">PARTIALLY DELIVERED</span>`;
        } else if (params.value === 'SHIPMENT_DELIVERED') {
          statusHtml = `<span class="badge bg-success">DELIVERED</span>`;
        } else if (params.value === 'SHIPMENT_INTRANSIT') {
            statusHtml = `<span class="badge bg-success-subtle text-dark">IN-TRANSIT</span>`;
        } else {
          statusHtml = `<span class="badge bg-dark">${params.value.split('_')[1] || params.value}</span>`;
        }
        return statusHtml;
      }
    },
    { headerName: 'Not Delivered', field: 'isundelivered', cellRenderer: CheckboxCellComponent, pinned: 'right' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      pinned: 'right'
    },
  ];
  userServiceCenter: any;
  fieldExecutiveList: any[] = [];
  rowData = [];
  editMode = false;
  selectedSCId: number;
  selectedAWBList: any[] = [];
  useEnterKey: any;
  private isDialogOpen = false; // Flag to track dialog state
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private drsService: DRSService,
    private awbService: AWBService,
    public modalService: NgbModal,
    public userManagmentService: UserManagementService,
    private utilities: Utilities,
    private titleService: Title,
    private companyService: CompanyService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    titleService.setTitle('DRS');
    this.context =
    {
      componentParent: this,
      componentName: 'DRSComponent',
    };
  }
  currentDateTime: any;
  minDateTime: string | number | Date;
  ngOnInit(): void {
    this.minDateTime = this.utilities.FormatDateWithTime(-1).dateTimeString;
    this.Id = this.route.snapshot.params['id'];
    this.editMode = this.Id ? true : false;
    this.currentDateTime = this.utilities.FormatDateWithTime().dateTimeString;
    this.drsForm = this.formBuilder.group({
      txtDrsNo: [{ value: this.drsFullNo, disabled: true }],
      txtDateTime: [this.currentDateTime, [Validators.required]],
      ddlFieldExecutive: [null],
      ddlCompany: [null],
      txtVehicleName: [null],
      ddlVehicleType: [null],
      txtVehicleOwner: [null],
      txtVOMContact: [null, Validators.pattern(regexPattern.telephone)],
      txtDriver: [null],
      txtDContact: [null, Validators.pattern(regexPattern.telephone)],
      txtAwbNo: [null, Validators.compose([Validators.maxLength(30)])],
      txtStatus: [false]
    });
    this.checkPermission();
    if (this.permConfig.isAddAllowed || this.permConfig.isEditAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => {
        this.selectedSCId = val;
        // console.log('this.selectedSCId', this.selectedSCId);
        this.loadDataFromAPI();
      });
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.drsForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.userServiceCenter = userData.metaInfo?.servicecenter;
    const permission = userData.config.filter(x => x.categoryname === 'DRSScan');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  loadDataFromAPI() {
    try {
      this.ngxLoaderService.start();
      forkJoin({
        usergroups: this.userManagmentService.GetUserByGroup('fe', this.selectedSCId),
        companies: this.companyService.GetAll({ scid: this.selectedSCId, isactive: true }),
        recievedawblist: this.awbService.getAwbReceivedList(this.selectedSCId)
      }).pipe(
        finalize(() => {
          if (this.editMode) {
            this.getDrsById();
          }
        })
      ).subscribe((val) => {
        if (val) {
          this.ngxLoaderService.stop();
          if (val.usergroups?.success && val.usergroups?.data) {
            const data = val.usergroups?.data;
            this.fieldExecutiveList = data.filter((item: any) => item.usergroupname === 'Field Executive');
          };

          if (val.companies?.success) {
            this.companyList = val.companies.data;
          };

          if (val.recievedawblist?.success && val.recievedawblist?.data) {
            if (!val.recievedawblist?.data?.length) {
              // this.appCoreService.showMessage('This service center has not recieved any shipment.', 'No Shipments Found.', 'warning')
              return;
            }
            // console.log(" getAllAvailableAwb",res.data)
            this.awbNoList = val.recievedawblist?.data.map(x => ({ ...x, bookingdate: this.utilities.FormatDateWithTime(0, x.bookingdate).dateString }));
          }
        }
      });

    } catch (e) {
      console.error(e);
    }
  };

  bindUsers() {
    // console.log("this.selectedSCId", this.selectedSCId);
    try {
      this.userManagmentService.GetUserByGroup('fe', this.selectedSCId).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          this.fieldExecutiveList = data.filter((item: any) => item.usergroupname === 'Field Executive');
        }
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDrsById() {
    if (this.Id) {
      try {
        this.ngxLoaderService.start();
        const res = await lastValueFrom(this.drsService.GetById(this.Id));
        if (res && res.success) {
          // this.bindDrsAWBList(this.Id);
          this.bindDrsDetails(res.data[0]);
          this.ngxLoaderService.stop();
        };
      } catch (error) {
      }
    }
  }

  bindDrsDetails(resData) {
    if (resData) {
      // console.log('resData', resData);
      this.isDelivered = resData?.status === 'DELIVERED' ? true : false;
      this.drsForm.get('txtDrsNo').setValue(resData?.drsfullno);
      this.drsFullNo = resData?.drsfullno;
      this.drsForm.get('txtDateTime').setValue(this.utilities.FormatDateWithTime(0, resData.datetime).dateTimeString);
      this.drsForm.get('ddlFieldExecutive').setValue(resData?.fieldexecutiveid);
      this.drsForm.get('ddlCompany').setValue(resData?.companyid);
      this.drsForm.get('txtDriver').setValue(resData.driverinfo?.name);
      this.drsForm.get('txtDContact').setValue(resData.driverinfo?.contactno);
      this.drsForm.get('txtVehicleName').setValue(resData.vehicleinfo?.name);
      this.drsForm.get('ddlVehicleType').setValue(resData.vehicleinfo?.type);
      this.drsForm.get('txtVehicleOwner').setValue(resData.vehicleinfo?.owner);
      this.drsForm.get('txtVOMContact').setValue(resData.vehicleinfo?.contactNo);
      for (const a of resData.drsawb) {
        a.bookingdate = this.utilities.FormatDateWithTime(0, a?.bookingdate).dateString;
        a.shippercity = a.origin;
        a.consigneecity = a.destination;
        a.customername = a.customer;
        a.consigneename = a.consignee;
        a.shippername = a.shipper;
        a.hideDelete = a.isundelivered
      };
      this.selectedAWBList = [];
      this.selectedAWBList = [...this.selectedAWBList, ...resData.drsawb];
      // console.log('selectedAWBList', this.selectedAWBList);

    }
  }

  async getAllAvailableAwb() {
    try {
      this.awbService.getAwbReceivedList(this.selectedSCId).subscribe(res => {
        if (res && res.success) {
          if (!res?.data.length) {
            // this.appCoreService.showMessage('This service center has not recieved any shipment.', 'No Shipments Found.', 'warning')
            return;
          }
          this.awbNoList = res.data.map(x => ({ ...x, bookingdate: this.utilities.formatDate(x.bookingdate).dateString }));
        }
      });
    } catch (e) {
    }
  }

  async addItems() {
    this.isFormSubmitted = true;
    const selectedAWBValue = this.drsForm.get('txtAwbNo').value;
    let selectedAWB: any = {};
    // console.log('selectedAWB ', selectedAWB);
    if (!selectedAWBValue || typeof selectedAWBValue === 'string') {
      selectedAWB = this.awbNoList.find(x => x.awbnumber === selectedAWBValue?.awbnumber?.trim());
      this.isFormSubmitted = false;
      if (!selectedAWB) {
        this.drsForm.get('txtAwbNo').reset();
        this.awbNoRef.nativeElement.focus();
        return this.appCoreService.showMessage('Please type AWB Number and Select from List to add in DRS', 'AWB Number not found', 'error')
      };
    }
    let isSelectedParentAWB = typeof selectedAWBValue !== 'string' && selectedAWBValue?.isparentawb;
    selectedAWB = { ...selectedAWBValue };
    selectedAWB.bookingdate = this.utilities.FormatDateWithTime(0, selectedAWB?.bookingdate)?.dateString;

    if (isSelectedParentAWB) {
      // check if it has any child awb's
      let childAwbList = this.awbNoList.filter(x =>
        x?.parentawbnumber === selectedAWB.awbnumber
        && (x?.parentawbnumber != null || x?.parentawbnumber != '')
        && !this.selectedAWBList.some(selected => selected.awbnumber === x.awbnumber));

      if (childAwbList.length) {
        await this.openAWBConfirmationDialog(childAwbList);
      } else {
        // add it to list
        if (!this.selectedAWBList.some(item => item.awbnumber === selectedAWB.awbnumber)) {
          this.selectedAWBList = [selectedAWB, ...this.selectedAWBList];
          //remove from awbNoList if added into List
          this.awbNoList = this.awbNoList.filter(item => item.awbnumber != selectedAWB.awnumber || item.awbnumber);
          let parentAwbNumber = selectedAWB.parentawbnumber;
          if (parentAwbNumber) {
            let hasChildren = this.awbNoList.some(item => item.parentawbnumber === parentAwbNumber);
            if (!hasChildren) {
              // Remove the parent AWB as well if no children are left
              this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== parentAwbNumber);
            }
          }
        }
      }
    } else {
      // add it to list
      if (!this.selectedAWBList.some(item => item.awbnumber === selectedAWB.awbnumber)) {
        this.selectedAWBList = [selectedAWB, ...this.selectedAWBList];
        //remove from awbNoList if added into List
        this.awbNoList = this.awbNoList.filter(item => item.awbnumber != selectedAWB.awnumber);
      }
    }
    this.drsForm.get('txtAwbNo').reset();
    this.awbNoList = this.awbNoList.filter(x => x.awbnumber != selectedAWB.awbnumber);

    this.changeDetectorRef.detectChanges();
    this.drsForm.get('txtAwbNo').reset();
    setTimeout(() => {
      this.awbNoRef.nativeElement.focus();
    }, 300);
  }

  addDrs() {
    this.isFormSubmitted = true;
    if (!this.permConfig.isAddAllowed) {
      this.errAlert('No Access to Add.');
      return;
    }

    this.isFormSubmitted = true;
    if (this.drsForm.invalid) {
      return;
    }

    if (!this.selectedAWBList.length) {
      this.appCoreService.showMessage('Cannot create empty DRS', 'Error', 'error');
      return;
    }

    const vehicleInfo = {
      name: this.drsForm.get('txtVehicleName')?.value,
      type: this.drsForm.get('ddlVehicleType')?.value,
      owner: this.drsForm.get('txtVehicleOwner')?.value,
      contactNo: this.drsForm.get('txtVOMContact')?.value
    }
    const driverInfo = {
      name: this.drsForm.get('txtDriver')?.value,
      contactno: this.drsForm.get('txtDContact')?.value
    }
    const drsAwb = {
      id: null,
      // awbnumbers: this.awbNoArray
      awbnumbers: this.selectedAWBList
    }
    const requestObj = {
      id: this.Id || null,
      drsfullno: this.drsFullNo || null,
      datetime: this.drsForm.get('txtDateTime')?.value,
      fieldexecutiveid: this.drsForm.get('ddlFieldExecutive')?.value,
      companyid: this.drsForm.get('ddlCompany')?.value,
      status: this.drsForm.get('txtStatus').value,
      vehicleinfo: vehicleInfo,
      driverinfo: driverInfo,
      drsawb: drsAwb,
      generatedfromid: this.selectedSCId,
    }
    // console.log('requestObj', requestObj);
    this.ngxLoaderService.start();
    this.drsService.Add(requestObj).subscribe((res) => {
      try {
        if (res) {
          if (!res.success) {
            this.ngxLoaderService.stop();
            this.errAlert(res.error.message);
            return;
          }
          if (res.success && res.data) {
            this.ngxLoaderService.stop();
            this.Id = res?.data?.Id;
            if (this.drsFullNo == null) {
              this.drsFullNo = res?.data?.drsfullno;
            }
            this.successDialog(res?.data?.Id, `Record ${this.editMode ? 'updated' : 'added'} successfully`);
            this.drsForm.get('txtDrsNo').setValue(res?.data?.drsfullno);
            this.getAllAvailableAwb();
            this.drsForm.get('txtAwbNo').reset();
            this.isFormSubmitted = false;
          }
        }
      } catch (err) {
        this.ngxLoaderService.stop();
        console.error(err);
      }
    });
  }

  onCheckBoxChange(event: any) {
    // console.log(event);
    if (event.checked) {
      let currentRowData = event.rowdata;

      const requestObj = {
        // id: this.podId,
        generatedfromid: this.selectedSCId,
        awbnumber: currentRowData?.awbnumber,
        statusupdate: 'Not Delivered',
        details: { remark: event?.rowdata?.reason },
        source: 'drs',
        drsid: this.Id
      }

      this.ngxLoaderService.start();
      try {
        this.awbService.UpdateStatus(requestObj).subscribe(res => {
          if (res && res?.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Status updated successsfully', 'Success', 'success');
            this.drsForm.get('txtAwbNo').reset();
            this.selectedAWBList = [];
            this.getDrsById();
            this.bindUsers();

          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }


    } else {
      this.appCoreService.showMessage('Cannot Inactivate. At least One record should be active', '', 'error');
    }
  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');
    }
    else if (this.selectedAWBList.length <= 1) {
      this.errAlert('Deletion of all records is not allowed.<br> DRS cannot be left empty.');
      return;
    }
    // else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
    else if (cell && cell.awbnumber) {
      const confirm = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (confirm) {
        this.awbNoList = [...this.awbNoList, ...this.selectedAWBList.filter(x => x.awbnumber == cell.awbnumber)];
        this.selectedAWBList = this.selectedAWBList.filter(item => item.awbnumber != cell.awbnumber);
      }
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
    //condition to hide/show the column
    const showUndeliveredColumn = this.editMode;
    this.gridColumnApi.setColumnVisible('isundelivered', showUndeliveredColumn);
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  }

  async successDialog(Id: number, msg?: any) {
    const success = await Swal.fire({
      // titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    if (success.isConfirmed) {
      this.router.navigate(['/operation/drs']);
    }
  }

  errAlert(msg: any) {
    Swal.fire({
      // titleText: 'Opps!',
      html: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  }
  AWBFormatter = (x: any) => x.awbnumber;

  searchAWBNumber: OperatorFunction<string, readonly { awbnumber; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.awbNoList?.filter((x: any) => x.awbnumber.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );


  async openAWBConfirmationDialog(arrayParam: any[]) {
    this.isDialogOpen = true; // Set flag before opening dialog

    const result = await Swal.fire({
      title: 'Confirmation',
      html: `<h5>This is a<b> Master AWB </b>number.</h5><h5>Do you want to manifest All its <b>child-AWB</b> numbers?</h5>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes. Select All',
      cancelButtonText: 'No. Select individually.',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.focus();
        }
      }
    });

    this.isDialogOpen = false; // Reset flag after dialog closes
    let tempSelectedArray: any[];
    if (result.isConfirmed) {
      tempSelectedArray = arrayParam.flatMap(item => item.awbnumber);

    } else {
      tempSelectedArray = await this.openChildAWBModel(arrayParam);
    }
    let selectedChildList = [];
    for (const awb of tempSelectedArray) {
      let selectedawb = this.awbNoList.filter(x => x.awbnumber === awb);
      this.awbNoList = this.awbNoList.filter(item => item.awbnumber != awb);
      let parentAwbNumber = selectedawb[0]?.parentawbnumber;
      if (parentAwbNumber) {
        let hasChildren = this.awbNoList.some(item => item.parentawbnumber === parentAwbNumber);
        if (!hasChildren) {
          // Remove the parent AWB as well if no children are left
          this.awbNoList = this.awbNoList.filter(item => item.awbnumber !== parentAwbNumber);
        }
      }
      let itemIdx = this.selectedAWBList.findIndex(x => x.awbnumber === selectedawb[0].awbnumber);
      if (itemIdx < 0) {
        selectedChildList.push(selectedawb[0]);
      }

    }

    this.selectedAWBList = [...this.selectedAWBList, ...selectedChildList];
  }

  async openChildAWBModel(childAWBList: any[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const modalRef = this.modalService.open(ChildAWBGridComponent, ngbModalOptions);
      modalRef.componentInstance.childAWBNoList = childAWBList
      modalRef.result.then(
        (result) => {
          if (result) {
            resolve(result);
          } else {
            resolve(null);
          }
        },
        (reason) => {
        }
      );
    });
  }

  validateDate(): void {
    const enteredDate = new Date(this.drsForm.get('txtDateTime')?.value);
    const minAllowedDate = new Date(this.minDateTime);

    if (isNaN(enteredDate.getTime()) || isNaN(minAllowedDate.getTime())) {
      // If either date is invalid, set an error (optional)
      this.drsForm.get('txtDateTime')?.setErrors({ invalidDate: true });
      return;
    }

    if (enteredDate < minAllowedDate) {
      this.drsForm.get('txtDateTime')?.setErrors({ minDate: true });
    } else {
      this.drsForm.get('txtDateTime')?.setErrors(null);
    }
  }


}
